import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { DashboardStats } from '@types'
import { dashboardService } from '@services/dashboardService'

interface DashboardState {
  statistics: DashboardStats
  loading: boolean
  error: string | null
}

const initialState: DashboardState = {
  statistics: {
    totalUsers: 0,
    totalSubscriptions: 0,
    totalGardens: 0,
    totalRevenue: 0,
    activeSubscriptions: 0,
    expiredSubscriptions: 0,
    cancelledSubscriptions: 0,
    todayDeliveries: 0,
    pendingDeliveries: 0,
  },
  loading: false,
  error: null,
}

// 异步actions
export const fetchDashboardData = createAsyncThunk(
  'dashboard/fetchData',
  async (_, { rejectWithValue }) => {
    try {
      const data = await dashboardService.getDashboardStats()
      return data
    } catch (error: any) {
      return rejectWithValue(error.message || '获取仪表板数据失败')
    }
  }
)

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    updateStatistics: (state, action: PayloadAction<Partial<DashboardStats>>) => {
      state.statistics = { ...state.statistics, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardData.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchDashboardData.fulfilled, (state, action: PayloadAction<DashboardStats>) => {
        state.loading = false
        state.statistics = action.payload
        state.error = null
      })
      .addCase(fetchDashboardData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { clearError, updateStatistics } = dashboardSlice.actions
export default dashboardSlice.reducer








